import { useQuery } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { listCompaniesEndpoint } from 'repositories/BerthApi/listCompanies/endpoint'
import type { Company, GetListCompaniesResponse } from 'repositories/BerthApi/listCompanies/type'
import { companyKeys } from 'repositories/queryKeys'

export type { Company }

export function useListCompanies(tenantId: string | null) {
  // Note: enabled=false のとき v4 の isLoading は true のまま残るため、
  // 実際にフェッチ中かを示す isInitialLoading (= isLoading && isFetching) を使う。
  const { data, isInitialLoading } = useQuery<GetListCompaniesResponse>({
    queryKey: companyKeys.list(tenantId ?? ''),
    queryFn: () => fetcher(listCompaniesEndpoint(tenantId!)),
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000,
  })

  return {
    companies: data?.data?.companies ?? [],
    isLoading: isInitialLoading,
  }
}
